/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import {
  SET_POLICY_FORM_DATA,
  SET_POLICY_ENTITIES_FILTERED_ITEMS,
  SET_POLICY_HIERARCHY_EXPANDED_ITEMS,
  SET_POLICY_HIERARCHY_ITEMS,
  SET_SELECTED_HIERARCHY,
  SET_HIERARCHY_SELECTED_KEYS,
  SET_POLICY_VALIDATION_ERROR,
  RESET_HIERARCHY_VALUES,
  RESET_POLICY_FORM_VALUES,
  SET_POLICY_MODULE_DEFAULT_VALUE,
  SET_EDIT_POLICY_FORM_DATA
} from "./types";

const initialState = {
  formValues: {
    name: '',
    description: '',
    module: [],
    entity: {
      key: 'select',
      displayName: 'Select',
      hierarchyLevelId: 'N/A'
    },
    hierarchy: [
      {
        values: []
      }
    ],
    action: []
  },
  defaultValues: {
    moduleItems: [
      { key: '1001110000', displayName: 'LDE' },
      { key: '1005020000', displayName: 'LRR' },
    ],
    entityItems: {
      key: 'select',
      displayName: 'Select',
      hierarchyLevelId: 'N/A'
    },
    actionItems: [
      { key: '1', displayName: 'Read' },
      { key: '2', displayName: 'Write' }
    ]
  },
  filteredValues: {
    entityItems: [{
      key: 'select',
      displayName: 'Select',
      hierarchyLevelId: 'N/A'
    }],
  },
  hierarchyValues: {
    expandedItems: [],
    hierarchyItems: [],
    selectedKeys: [],
    selectedHierarchy: []
  },
  formValidation: {
    defaultValues: {
      error: false,
      errorPolicyNameHelperText: '',
      errorPolicyEntityHelperText: '',
      errorPolicyDescriptionHelperText: '',
      errorPolicyModuleHelperText: '',
      errorPolicyActionHelperText: '',
      errorPolicyHierarchyHelperText: ''
    },
    errorFormValues: {
      error: false,
      errorPolicyNameHelperText: '',
      errorPolicyEntityHelperText: '',
      errorPolicyDescriptionHelperText: '',
      errorPolicyModuleHelperText: '',
      errorPolicyActionHelperText: '',
      errorPolicyHierarchyHelperText: ''
    }
  }
}

export const dataReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_POLICY_FORM_DATA:
      return {
        ...state,
        formValues: { ...state.formValues, ...action.data },
      }
    case SET_POLICY_ENTITIES_FILTERED_ITEMS:
      return {
        ...state,
        filteredValues: { ...state.filteredValues, entityItems: [...action.entityItems] },
      }
    case SET_POLICY_HIERARCHY_EXPANDED_ITEMS:
      return {
        ...state,
        hierarchyValues: { ...state.hierarchyValues, expandedItems: [...action.expandedItems] },
      }
    case SET_POLICY_HIERARCHY_ITEMS:
      return {
        ...state,
        hierarchyValues: { ...state.hierarchyValues, hierarchyItems: [...action.hierarchyItems] },
      }
    case SET_SELECTED_HIERARCHY:
      return {
        ...state,
        hierarchyValues: { ...state.hierarchyValues, selectedHierarchy: [...action.selectedHierarchy] },
      }
    case SET_HIERARCHY_SELECTED_KEYS:
      return {
        ...state,
        hierarchyValues: { ...state.hierarchyValues, selectedKeys: [...action.selectedKeys] },
      }
    case RESET_HIERARCHY_VALUES:
      return {
        ...state,
        hierarchyValues: { ...state.hierarchyValues, expandedItems: [], selectedKeys: [], hierarchyItems: [], selectedHierarchy: [] },
      }
    case RESET_POLICY_FORM_VALUES:
      return {
        ...state,
        hierarchyValues: {
          ...state.hierarchyValues,
          expandedItems: [],
          hierarchyItems: [],
          selectedKeys: [],
          selectedHierarchy: []
        },
        formValues: {
          ...state.formValues,
          name: '',
          description: '',
          module: [],
          entity: {
            key: 'select',
            displayName: 'Select',
            hierarchyLevelId: 'N/A'
          },
          hierarchy: [
            {
              values: []
            }
          ],
          action: []
        },
      }
    case SET_POLICY_VALIDATION_ERROR:
      return {
        ...state,
        formValidation: { ...state.formValidation, errorFormValues: { ...action.errorFormValues } },
      }
    case SET_POLICY_MODULE_DEFAULT_VALUE:
      return {
        ...state,
        formValues: { ...state.formValues, module: [] },
      }
    case SET_EDIT_POLICY_FORM_DATA:
      return {
        ...state,
        formValues: { ...state.formValues, ...action.data }
      }
    default:
      return state;
  }
}